export enum AppStep {
  START,
  CHECKLIST,
  SUMMARY
}

export enum Step {
  FAUCET,
  WATER_HEATER,
  WATER_WASTEWATER,
  DRAINS,
  SMOKE_DETECTORS,
  FIRE_EQUIPMENT,
  KITCHEN_FAN
}

export enum ScenarioStep {
  START = 'start',
  FAUCET = 'stoppekran',
  WATER_HEATER = 'varmtvannsbereder',
  WATER_WASTEWATER = 'synlige-ror',
  DRAINS = 'sluk',
  SMOKE_DETECTORS = 'roykvarsler',
  FIRE_EQUIPMENT = 'brannslukningsapparat',
  KITCHEN_FAN = 'kjokkenventilator',
  SUMMARY = 'oppsummering'
}

export type StepType = typeof ScenarioStep[keyof typeof ScenarioStep];
